import React, { useEffect, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useTenantBranding } from './hooks/useTenantBranding';
import './index.css';
import HomePage from './components/HomePage';
import SignIn from './components/SignIn';
import SignUp from './components/SignUp';
import ApplicationForm from './components/ApplicationForm';
import ApplicationStatus from './components/ApplicationStatus';
import ResetPassword from './components/ResetPassword';
import PasswordChangeGate from './components/PasswordChangeGate';
import Applications from './super-admin/Applications';
import SuperAdminDashboard from './super-admin/Dashboard';
import PricingManagement from './super-admin/PricingManagement';
import PaymentManagement from './super-admin/PaymentManagement';
import BackupManagement from './super-admin/BackupManagement';
import SubscriptionManagement from './super-admin/SubscriptionManagement';
import Dashboard from './Tenant/Dashboard';
import COELandingPage from './ControllerofExammination';
import PromotionPolicies from './ControllerofExammination/PromotionPolicies';
import StudentPromotionManager from './ControllerofExammination/StudentPromotionManager';
import PromoteStudents from './ControllerofExammination/PromoteStudents';
import FacultyDashboard from './Faculty/Dashboard';
import StudentDashboard from './Student/Dashboard';
import ParentDashboard from './Parent/Dashboard';
import ChildDetails from './Parent/ChildDetails';
import Tenants from './super-admin/tenants';
import SubdomainAccess from './SubdomainAccess';
import Admin from './Tenant-Admin/Admin';
import ProtectedRoute from './components/ProtectedRoute';
import CreateOrganization from './Tenant-Admin/CreateOrganization';
import ManageOrganization from './Tenant-Admin/ManageOrganization';
import AcademicYearNew from './Tenant-Admin/AcademicComponents/AcademicYear';
import ManageStaff from './Tenant-Admin/ManageStaff/ManageStaff';
import Department from './Tenant-Admin/Department-Components/Department';
import ManageClasses from './Tenant-Admin/Class-Manager/ManageClasses';
import WebsiteManager from './Tenant-Admin/WebsiteManager/WebsiteManager';
import ManageStudents from './Tenant-Admin/Student-Management-Component/index';
import AddStudent from './Tenant-Admin/Student-Management-Component/components/AddStudent';
import EditStudent from './Tenant-Admin/Student-Management-Component/components/EditStudent';
import TimeTable from './Tenant-Admin/TimeTable';
import SubjectAttendanceRules from './Tenant-Admin/Subject-Attendance-Rules/SubjectAttendanceRules';
import Programs from './Tenant-Admin/Programs/Programs';
import ExamComponentManager from './ControllerofExammination/ExamComponentManager';
import ProgramCourseOutcomes from './ControllerofExammination/ProgramCourseOutcomes';
import ExamPaperTemplateManager from './ControllerofExammination/ExamPaperTemplateManager';
import FinalizedTemplateManagement from './ControllerofExammination/FinalizedTemplateManagement';
import EvaluationAssignment from './ControllerofExammination/EvaluationAssignment';
import AssignPaperToSubject from './ControllerofExammination/AssignPaperToSubject';
import MarkEntryStudentList from './Faculty/components/MarkEntryStudentList';
import COEMarksDashboard from './ControllerofExammination/COEMarksDashboard';
import COESubjectMarks from './ControllerofExammination/COESubjectMarks';
import StudentCieMarksForm from './ControllerofExammination/StudentCieMarks';
import EndExamMarksManager from './ControllerofExammination/EndExamMarksManager';
import ManageEvaluators from './ControllerofExammination/ManageEvaluators';
import AssignEvaluatorToSubject from './ControllerofExammination/AssignEvaluatorToSubject';
import EvaluatorDashboard from './Evaluators/Dashboard';
import EvaluatorWorkspace from './Evaluators/EvaluatorWorkspace';
import PacketManager from './ControllerofExammination/PacketManager';
import DirectPromotionWorkflow from './ControllerofExammination/DirectPromotionWorkflow';
import RegularPromotion from './ControllerofExammination/RegularPromotion';
import PromotionBatches from './ControllerofExammination/PromotionBatches';
import CommunicationPanel from './Tenant-Admin/Communication/CommunicationPanel';
import { TenantProvider as TenantAdminProvider } from './Tenant-Admin/Layout/TenantContext';
import { TenantSubscriptionDashboard } from './Tenant-Admin/Subscription';
import StorageManagement from './Tenant-Admin/StorageManagement';
import BlogPost from './components/PublicPages/Blog/BlogPost';
// ============ PUBLIC LEGAL PAGES IMPORT ============
import { 
  TermsOfService, 
  PrivacyPolicy, 
  RefundPolicy,
  AboutUs,
  ContactUs,
  DemoRequest
} from './components/PublicPages';

// ============ LEGAL DOCUMENTS IMPORT ============
import LegalDocuments from './super-admin/LegalDocuments';
import TenantLegalDocuments from './Tenant-Admin/LegalDocuments';

// ============ DEMO REQUESTS IMPORT ============
import DemoRequests from './super-admin/DemoRequests';

// ============ HEAD OF INSTITUTION IMPORTS ============
import HeadOfInstitutionDashboard from './Head-Of-Institution/Dashboard';
import HeadOfInstitutionStudents from './Head-Of-Institution/Students';
import HeadOfInstitutionClasses from './Head-Of-Institution/Classes';
import HeadOfInstitutionFaculty from './Head-Of-Institution/Faculty';
import HeadOfInstitutionAttendance from './Head-Of-Institution/Attendance';
import HeadOfInstitutionPerformance from './Head-Of-Institution/Performance';
import HeadOfInstitutionDepartments from './Head-Of-Institution/Departments';
import HeadOfInstitutionCalendar from './Head-Of-Institution/Calendar';
import HeadOfInstitutionReports from './Head-Of-Institution/Reports';
import HeadOfInstitutionSettings from './Head-Of-Institution/Settings';
import { TenantProvider as HOITenantProvider } from './Head-Of-Institution/TenantContext';

// ============ HEAD OF DEPARTMENT IMPORTS ============
import HODDashboard from './Head-of-Department/Dashboard';
import HODDepartment from './Head-of-Department/Department';
import LiveMonitoring from './Head-of-Department/LiveMonitoring/LiveMonitoring';
import HODClassManager from './Head-of-Department/ClassManager';
import HODClassDetails from './Head-of-Department/HODClassDetails';
import HODTimetable from './Head-of-Department/Timetable';

// ============ LIVE MONITORING IMPORT ============
import LiveMonitoringHOI from './Head-Of-Institution/LiveMonitoring/LiveMonitoring';

// ============ LIBRARY IMPORTS ============
import LibraryDashboard from './Library/Dashboard';
import Books from './Library/Books';
import Transactions from './Library/Transactions';
import Members from './Library/Members';
import IssueBook from './Library/IssueBook';
import ReturnBook from './Library/ReturnBook';

// ============ TOAST PROVIDER ============
import { ToastProvider } from './super-admin/components';

// ============ SCROLL TO TOP COMPONENT ============
import ScrollToTop from './components/ScrollToTop';

// ============ CLASS DETAILS PAGE IMPORT ============
import ClassDetailsPage from './Tenant-Admin/Class-Manager/pages/ClassDetailsPage';

// Renamed core page component file mapping
import SubjectDetails from './Faculty/components/SubjectDetails';





// Wrapper for MarkEntryStudentList to get state from navigation
function MarkEntryStudentListWrapper() {
  const location = useLocation();
  const { assignmentId, assignment, subjectId, subjectName, classId, componentId, itemId } = location.state || {};
  return (
    <div>
      <MarkEntryStudentList
        assignmentId={assignmentId}
        assignment={assignment}
        subjectId={subjectId}
        subjectName={subjectName}
        classId={classId}
        componentId={componentId}
        itemId={itemId}
      />
    </div>
  );
}

function StudentCieMarksFormWrapper() {
  const location = useLocation();
  const state = location.state || {};
  return <StudentCieMarksForm {...state} />;
}

function PromoteStudentsWrapper() {
  const location = useLocation();
  const state = location.state || {};
  return <PromoteStudents {...state} />;
}

function PromotionBatchesWrapper() {
  const location = useLocation();
  const state = location.state || {};
  return <PromotionBatches tenantId={state?.tenantId || localStorage.getItem('tenantId')} />;
}

// Declarative route safety controller wrapping the main Subject Details view
function SubjectActionsWrapper() {
  const location = useLocation();
  const state = location.state || {};
  
  const { classItem, subject, labBatch, facultyId, classId, subjectId, onReopenClassModal } = state;

  if (!classId || !subjectId) {
    return <Navigate to="/faculty/dashboard" replace />;
  }

  const handleClose = () => {
    if (typeof onReopenClassModal === 'function') {
      onReopenClassModal({ classItem, subject, labBatch });
    } else {
      window.history.back();
    }
  };

  return (
    <div className="min-h-screen w-full bg-slate-50">
      <SubjectDetails
        isOpen={true}
        onClose={handleClose}
        classItem={classItem}
        subject={subject}
        facultyId={facultyId}
        labBatch={labBatch}
      />
    </div>
  );
}

const AttendancePageLazy = React.lazy(() => import('./Tenant-Admin/Attendance'));

// Block all console logs in production
const env = process.env.REACT_APP_ENV;
if (env === 'prod' || env === 'test') {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
}

// ============================================
// PARENT LAYOUT
// ============================================
const ParentLayout = () => {
  return (
    <Routes>
      <Route path="dashboard" element={<ParentDashboard />} />
      <Route path="child" element={<ChildDetails />} />
      <Route path="" element={<Navigate to="/parent/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/parent/dashboard" replace />} />
    </Routes>
  );
};

// ============================================
// LIBRARY LAYOUT
// ============================================
const LibraryLayout = () => {
  return (
    <Routes>
      <Route path="dashboard" element={<LibraryDashboard />} />
      <Route path="books" element={<Books />} />
      <Route path="transactions" element={<Transactions />} />
      <Route path="members" element={<Members />} />
      <Route path="reports" element={<div>Reports Coming Soon</div>} />
      <Route path="settings" element={<div>Settings Coming Soon</div>} />
      <Route path="" element={<Navigate to="/librarian/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/librarian/dashboard" replace />} />
      <Route path="transactions/issue" element={<IssueBook />} />
      <Route path="transactions/return" element={<ReturnBook />} />
    </Routes>
  );
};

// ============================================
// HEAD OF DEPARTMENT ROUTES WRAPPER
// ============================================
const HODRoutes = () => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const tenantId = localStorage.getItem('tenantId');
  const organizationId = localStorage.getItem('organizationId');
  const userId = localStorage.getItem('userId');
  const token = localStorage.getItem('token');
  const userRole = localStorage.getItem('userRole');

  return (
    <Routes>
      {/* HOD Dashboard */}
      <Route 
        path="dashboard" 
        element={
          <ProtectedRoute allowedRoles={["hod"]}>
            <HODDashboard 
              user={user}
              userId={userId}
              tenantId={tenantId}
              organizationId={organizationId}
              token={token}
              userRole={userRole}
            />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="class-details" 
        element={
          <ProtectedRoute allowedRoles={["hod"]}>
            <HODClassDetails />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="timetable" 
        element={
          <ProtectedRoute allowedRoles={["hod"]}>
            <HODTimetable />
          </ProtectedRoute>
        } 
      />
      {/* HOD Live Monitoring */}
      <Route 
        path="live-monitoring" 
        element={
          <ProtectedRoute allowedRoles={["hod"]}>
            <LiveMonitoring />
          </ProtectedRoute>
        } 
      />

      {/* HOD Department */}
      <Route 
        path="department" 
        element={
          <ProtectedRoute allowedRoles={["hod"]}>
            <HODDepartment 
              tenantId={tenantId}
              userId={userId}
              token={token}
              userRole={userRole}
            />
          </ProtectedRoute>
        } 
      />

      {/* HOD Classes (Manage Classes) */}
      <Route 
        path="classes" 
        element={
          <ProtectedRoute allowedRoles={["hod"]}>
            <HODClassManager />
          </ProtectedRoute>
        } 
      />

      {/* ✅ HOD Class Details - NEW */}
      <Route 
        path="class-details" 
        element={
          <ProtectedRoute allowedRoles={["hod"]}>
            <ClassDetailsPage />
          </ProtectedRoute>
        } 
      />

      {/* HOD Faculty Timetable - Placeholder route */}
      <Route 
        path="faculty-timetable" 
        element={
          <ProtectedRoute allowedRoles={["hod"]}>
            <div className="min-h-screen bg-slate-50 dark:bg-gray-900 p-8">
              <h1 className="text-2xl font-bold text-slate-900 dark:text-white">Faculty Timetable</h1>
              <p className="text-slate-600 dark:text-slate-400 mt-2">Faculty timetable view coming soon...</p>
            </div>
          </ProtectedRoute>
        } 
      />

      {/* HOD Attendance - Placeholder route */}
      <Route 
        path="attendance" 
        element={
          <ProtectedRoute allowedRoles={["hod"]}>
            <div className="min-h-screen bg-slate-50 dark:bg-gray-900 p-8">
              <h1 className="text-2xl font-bold text-slate-900 dark:text-white">Attendance Overview</h1>
              <p className="text-slate-600 dark:text-slate-400 mt-2">Attendance monitoring coming soon...</p>
            </div>
          </ProtectedRoute>
        } 
      />

      {/* HOD Performance - Placeholder route */}
      <Route 
        path="performance" 
        element={
          <ProtectedRoute allowedRoles={["hod"]}>
            <div className="min-h-screen bg-slate-50 dark:bg-gray-900 p-8">
              <h1 className="text-2xl font-bold text-slate-900 dark:text-white">Performance Analytics</h1>
              <p className="text-slate-600 dark:text-slate-400 mt-2">Performance analytics coming soon...</p>
            </div>
          </ProtectedRoute>
        } 
      />

      {/* HOD Faculty Management - Placeholder route */}
      <Route 
        path="faculty" 
        element={
          <ProtectedRoute allowedRoles={["hod"]}>
            <div className="min-h-screen bg-slate-50 dark:bg-gray-900 p-8">
              <h1 className="text-2xl font-bold text-slate-900 dark:text-white">Faculty Management</h1>
              <p className="text-slate-600 dark:text-slate-400 mt-2">Faculty management coming soon...</p>
            </div>
          </ProtectedRoute>
        } 
      />

      {/* HOD Settings - Placeholder route */}
      <Route 
        path="settings" 
        element={
          <ProtectedRoute allowedRoles={["hod"]}>
            <div className="min-h-screen bg-slate-50 dark:bg-gray-900 p-8">
              <h1 className="text-2xl font-bold text-slate-900 dark:text-white">Department Settings</h1>
              <p className="text-slate-600 dark:text-slate-400 mt-2">Settings coming soon...</p>
            </div>
          </ProtectedRoute>
        } 
      />

      <Route path="" element={<Navigate to="dashboard" replace />} />
      <Route path="*" element={<Navigate to="dashboard" replace />} />
    </Routes>
  );
};

// ============================================
// HEAD OF INSTITUTION ROUTES WRAPPER
// ============================================
const HeadOfInstitutionRoutes = () => {
  return (
    <HOITenantProvider>
      <Routes>
        <Route 
          path="dashboard" 
          element={
            <ProtectedRoute allowedRoles={["head_of_institution", "principal"]}>
              <HeadOfInstitutionDashboard />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="classes" 
          element={
            <ProtectedRoute allowedRoles={["head_of_institution", "principal"]}>
              <HeadOfInstitutionClasses />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="students" 
          element={
            <ProtectedRoute allowedRoles={["head_of_institution", "principal"]}>
              <HeadOfInstitutionStudents />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="faculty" 
          element={
            <ProtectedRoute allowedRoles={["head_of_institution", "principal"]}>
              <HeadOfInstitutionFaculty />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="attendance" 
          element={
            <ProtectedRoute allowedRoles={["head_of_institution", "principal"]}>
              <HeadOfInstitutionAttendance />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="performance" 
          element={
            <ProtectedRoute allowedRoles={["head_of_institution", "principal"]}>
              <HeadOfInstitutionPerformance />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="departments" 
          element={
            <ProtectedRoute allowedRoles={["head_of_institution", "principal"]}>
              <HeadOfInstitutionDepartments />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="calendar" 
          element={
            <ProtectedRoute allowedRoles={["head_of_institution", "principal"]}>
              <HeadOfInstitutionCalendar />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="reports" 
          element={
            <ProtectedRoute allowedRoles={["head_of_institution", "principal"]}>
              <HeadOfInstitutionReports />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="settings" 
          element={
            <ProtectedRoute allowedRoles={["head_of_institution", "principal"]}>
              <HeadOfInstitutionSettings />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="live-monitoring" 
          element={
            <ProtectedRoute allowedRoles={["head_of_institution", "principal"]}>
              <LiveMonitoringHOI />
            </ProtectedRoute>
          } 
        />
        <Route path="" element={<Navigate to="dashboard" replace />} />
        <Route path="*" element={<Navigate to="dashboard" replace />} />
      </Routes>
    </HOITenantProvider>
  );
};

// ============================================
// TENANT ADMIN ROUTES WRAPPER
// ============================================
const TenantAdminRoutes = () => {
  const userId = typeof window !== 'undefined' ? localStorage.getItem('userId') : null;
  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const MAIN_DOMAIN = process.env.REACT_APP_MAIN_DOMAIN || 'truyon.com';
  
  const getSubdomain = (hostname, mainDomain) => {
    let parts = hostname.split('.');
    const mainParts = mainDomain.split('.');
    
    if (parts[0] === 'www' && hostname !== `www.${mainDomain}`) {
      parts.shift();
    }
    
    if (parts.length > mainParts.length) {
      const subdomainParts = parts.slice(0, parts.length - mainParts.length);
      return subdomainParts.length > 0 ? subdomainParts.join('.') : null;
    }
    return null;
  };

  const subdomain = getSubdomain(hostname, MAIN_DOMAIN);
  const tenantInfo = { subdomain };

  return (
    <TenantAdminProvider>
      <Routes>
        <Route path="admin" element={<Admin />} />
        <Route path="create-organization/:tenantId" element={<CreateOrganization />} />
        <Route path="manage-organization/:tenantId" element={<ManageOrganization />} />
        <Route path="academic-components/academic-year/:tenantId" element={<AcademicYearNew />} />
        <Route path="manage-staff/:tenantId" element={<ManageStaff />} />
        <Route path="department" element={<Department />} />
        <Route path="class-manager" element={<ManageClasses />} />
        <Route path="class-details" element={<ClassDetailsPage />} />
        
        {/* ✅ FIX: Removed ModuleProtectedRoute wrapper - Admin.js already checks access via API */}
        <Route path="website-manager" element={<WebsiteManager />} />
        
        <Route path="manage-students" element={<ManageStudents />} />
        <Route path="add-student" element={<AddStudent />} />
        <Route path="edit-student/:studentId" element={<EditStudent />} />
        <Route path="timetable" element={<TimeTable />} />
        <Route path="subject-attendance-rules" element={
          <SubjectAttendanceRules userId={userId} token={token} tenantInfo={tenantInfo} />
        } />
        <Route path="attendance/*" element={
          <Suspense fallback={<div>Loading...</div>}>
            <AttendancePageLazy />
          </Suspense>
        } />
        <Route path="programs" element={<Programs />} />
        <Route path="program-course-outcomes" element={<ProgramCourseOutcomes />} />
        <Route path="exam-paper-templates" element={<ExamPaperTemplateManager />} />
        <Route path="exam-component-manager" element={<ExamComponentManager />} />
        <Route path="promotion-policies" element={<PromotionPolicies />} />
        <Route path="finalized-template-management" element={<FinalizedTemplateManagement />} />
        <Route path="coe/finalized-templates" element={
          <ProtectedRoute allowedRoles={["coe"]}>
            <FinalizedTemplateManagement 
              user={typeof window !== 'undefined' ? JSON.parse(localStorage.getItem('user') || '{}') : {}}
              tenant={tenantInfo}
              orgInfo={typeof window !== 'undefined' ? JSON.parse(localStorage.getItem('orgInfo') || '{}') : {}}
            />
          </ProtectedRoute>
        } />
        <Route path="legal-documents" element={
          <ProtectedRoute allowedRoles={["tenant_admin"]}>
            <TenantLegalDocuments />
          </ProtectedRoute>
        } />
        <Route path="communication" element={
          <ProtectedRoute allowedRoles={["tenant_admin"]}>
            <CommunicationPanel />
          </ProtectedRoute>
        } />
        <Route path="subscription" element={
          <ProtectedRoute allowedRoles={["tenant_admin"]}>
            <TenantSubscriptionDashboard />
          </ProtectedRoute>
        } />
        <Route path="storage" element={
          <ProtectedRoute allowedRoles={["tenant_admin"]}>
            <StorageManagement />
          </ProtectedRoute>
        } />
        <Route path="" element={<Navigate to="/tenant-admin/admin" replace />} />
        <Route path="*" element={<Navigate to="/tenant-admin/admin" replace />} />
      </Routes>
    </TenantAdminProvider>
  );
};

// ============================================
// FACULTY LAYOUT
// ============================================
const FacultyLayout = () => {
  return (
    <Routes>
      <Route path="dashboard" element={<FacultyDashboard />} />
      <Route path="mark-entry" element={<MarkEntryStudentListWrapper />} />
      <Route path="class-subject-details" element={<SubjectActionsWrapper />} />
      <Route path="" element={<Navigate to="/faculty/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/faculty/dashboard" replace />} />
    </Routes>
  );
};

// ============================================
// STUDENT LAYOUT
// ============================================
const StudentLayout = () => {
  return (
    <Routes>
      <Route path="dashboard" element={<StudentDashboard />} />
      <Route path="" element={<Navigate to="/student/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/student/dashboard" replace />} />
    </Routes>
  );
};

// ============================================
// SUPER ADMIN LAYOUT
// ============================================
const SuperAdminLayout = () => {
  return (
    <Routes>
      <Route path="dashboard" element={<SuperAdminDashboard />} />
      <Route path="applications" element={<Applications />} />
      <Route path="tenants" element={<Tenants />} />
      <Route path="pricing" element={<PricingManagement />} />
      <Route path="payments" element={<PaymentManagement />} />
      <Route path="backup" element={<BackupManagement />} />
      <Route path="subscription" element={<SubscriptionManagement />} />
      
      {/* ============ DEMO REQUESTS ROUTE ============ */}
      <Route path="demo-requests" element={<DemoRequests />} />
      
      {/* ============ LEGAL DOCUMENTS ROUTE ============ */}
      <Route path="legal-documents/*" element={<LegalDocuments />} />
      
      <Route path="" element={<Navigate to="/super-admin/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/super-admin/dashboard" replace />} />
    </Routes>
  );
};

// ============================================
// APP COMPONENT
// ============================================
const App = () => {
  const hostname = window.location.hostname;
  const MAIN_DOMAIN = process.env.REACT_APP_MAIN_DOMAIN || 'truyon.com';

  const isMainDomain = () => {
    const cleanHostname = hostname.replace(/^www\./, '');
    const cleanMainDomain = MAIN_DOMAIN.replace(/^www\./, '');
    return cleanHostname === cleanMainDomain;
  };

  const getSubdomain = (hostname, mainDomain) => {
    let parts = hostname.split('.');
    const mainParts = mainDomain.split('.');
    
    if (parts[0] === 'www' && hostname !== `www.${mainDomain}`) {
      parts.shift();
    }
    
    if (parts.length > mainParts.length) {
      const subdomainParts = parts.slice(0, parts.length - mainParts.length);
      return subdomainParts.length > 0 ? subdomainParts.join('.') : null;
    }
    return null;
  };

  const mainDomainCheck = isMainDomain();
  const subdomain = mainDomainCheck ? null : getSubdomain(hostname, MAIN_DOMAIN);
  const isSubdomain = !mainDomainCheck && subdomain !== null && hostname.endsWith(MAIN_DOMAIN);

  useTenantBranding(isSubdomain);

  useEffect(() => {
    if (hostname.startsWith('www.') && hostname !== `www.${MAIN_DOMAIN}` && subdomain) {
      const newHostname = hostname.replace(/^www\./, '');
      if (window.location.hostname !== newHostname) {
        window.location.href = `${window.location.protocol}//${newHostname}${window.location.pathname}${window.location.search}`;
      }
    }
  }, [hostname, MAIN_DOMAIN, subdomain]);

  // ============================================
  // MAIN APP CONTENT
  // ============================================
  const AppContent = () => {
    if (isSubdomain) {
      return (
        <Routes>
          <Route path="/change-password" element={<PasswordChangeGate />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/" element={<Dashboard subdomain={subdomain} />} />
          <Route path="/dashboard" element={<Dashboard subdomain={subdomain} />} />
          
          {/* ============ HEAD OF DEPARTMENT ROUTES ============ */}
          <Route path="/hod/*" element={
            <ProtectedRoute allowedRoles={["hod"]}>
              <HODRoutes />
            </ProtectedRoute>
          } />
          
          {/* ============ HEAD OF INSTITUTION ROUTES ============ */}
          <Route path="/head-of-institution/*" element={<HeadOfInstitutionRoutes />} />
          
          {/* ============ LIBRARY ROUTES ============ */}
          <Route path="/librarian/*" element={
            <ProtectedRoute allowedRoles={["librarian"]}>
              <LibraryLayout />
            </ProtectedRoute>
          } />
          
          {/* ============ COE ROUTES ============ */}
          <Route path="/coe" element={
            <ProtectedRoute allowedRoles={["coe"]}>
              <COELandingPage />
            </ProtectedRoute>
          } />
          <Route path="/coe/*" element={
            <ProtectedRoute allowedRoles={["coe"]}>
              <Routes>
                <Route path="exam-paper-templates" element={<ExamPaperTemplateManager />} />
                <Route path="evaluation-assignment" element={<EvaluationAssignment />} />
                <Route path="assign-paper-to-subject" element={<AssignPaperToSubject />} />
                <Route path="student-promotion-manager" element={<StudentPromotionManager />} />
                <Route path="promote-students" element={<PromoteStudentsWrapper />} />
                <Route path="promotion-batches" element={<PromotionBatchesWrapper />} />
                <Route path="manage-evaluators" element={<ManageEvaluators />} />
                <Route path="student-promotion/direct" element={<DirectPromotionWorkflow />} />
                <Route path="student-promotion/regular" element={<RegularPromotion />} />
                <Route path="assign-evaluator-to-subject" element={<AssignEvaluatorToSubject />} />
                <Route path="packet-manager" element={<PacketManager />} />
                <Route path="promotion-policies" element={<PromotionPolicies />} />
                <Route path="exam-component-manager" element={<ExamComponentManager />} />
                <Route path="dashboard" element={<COEMarksDashboard />} />
                <Route path="subject-marks" element={<COESubjectMarks />} />
                <Route path="student-marks" element={<StudentCieMarksFormWrapper />} />
                <Route path="end-exam-marks" element={<EndExamMarksManager />} />
                <Route path="program-course-outcomes" element={<ProgramCourseOutcomes />} />
                <Route path="finalized-templates" element={<FinalizedTemplateManagement />} />
                <Route path="" element={<Navigate to="/coe" replace />} />
                <Route path="*" element={<Navigate to="/coe" replace />} />
              </Routes>
            </ProtectedRoute>
          } />
          
          {/* ============ EVALUATOR ROUTES ============ */}
          <Route path="/evaluator/*" element={
            <ProtectedRoute allowedRoles={["evaluator"]}>
              <Routes>
                <Route path="dashboard" element={<EvaluatorDashboard />} />
                <Route path="workspace" element={<EvaluatorWorkspace />} />
                <Route path="" element={<Navigate to="/evaluator/dashboard" replace />} />
                <Route path="*" element={<Navigate to="/evaluator/dashboard" replace />} />
              </Routes>
            </ProtectedRoute>
          } />
          
          {/* ============ TENANT ADMIN ROUTES ============ */}
          <Route path="/tenant-admin/*" element={
            <ProtectedRoute allowedRoles={["tenant_admin"]}>
              <TenantAdminRoutes />
            </ProtectedRoute>
          } />
          
          {/* ============ FACULTY ROUTES ============ */}
          <Route path="/faculty/*" element={
            <ProtectedRoute allowedRoles={["faculty"]}>
              <FacultyLayout />
            </ProtectedRoute>
          } />
          
          {/* ============ STUDENT ROUTES ============ */}
          <Route path="/student/*" element={
            <ProtectedRoute allowedRoles={["student"]}>
              <StudentLayout />
            </ProtectedRoute>
          } />
          
          {/* ============ PARENT ROUTES ============ */}
          <Route path="/parent/*" element={
            <ProtectedRoute allowedRoles={["parent"]}>
              <ParentLayout />
            </ProtectedRoute>
          } />
          
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      );
    } else {
      return (
        <Routes>
          {/* ============ PUBLIC LEGAL PAGES ============ */}
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/blog" element={<BlogPost />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/blog/*" element={<BlogPost />} />

          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/request-demo" element={<DemoRequest />} />
          <Route path="/requestdemo" element={<DemoRequest />} />

          {/* ============ REDIRECTS FOR COMMON VARIATIONS ============ */}
          <Route path="/terms" element={<Navigate to="/terms-of-service" replace />} />
          <Route path="/privacy" element={<Navigate to="/privacy-policy" replace />} />
          <Route path="/refund" element={<Navigate to="/refund-policy" replace />} />
          <Route path="/aboutus" element={<Navigate to="/about-us" replace />} />

          {/* ============ MAIN DOMAIN ROUTES ============ */}
          <Route path="/" element={<HomePage />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/apply" element={<ApplicationForm />} />
          <Route path="/application-form" element={<ApplicationForm />} />
          <Route path="/application-status" element={<ApplicationStatus />} />
          <Route path="/change-password" element={<PasswordChangeGate />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          
          <Route path="/super-admin/*" element={
            <ProtectedRoute allowedRoles={["super_admin"]}>
              <SuperAdminLayout />
            </ProtectedRoute>
          } />
          
          <Route path="/:subdomain" element={<SubdomainAccess />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      );
    }
  };

  return (
    <Router>
      <ScrollToTop />
      <ToastProvider>
        <AppContent />
      </ToastProvider>
    </Router>
  );
};

export default App;